/* eslint-disable no-unused-vars */
import React, { useEffect, useRef } from 'react';
import { useFloating, flip, offset, shift } from '@floating-ui/react-dom';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import * as S from './DropdownMenu.styled';

export const DropdownMenu = ({
  children,
  isOpen,
  setIsOpen,
  BtnElement,
  defaultPlacement = 'bottom-start',
}) => {
  const { x, y, strategy, refs, update } = useFloating({
    middleware: [flip(), shift(), offset({ mainAxis: 5, crossAxis: 5 })],
    placement: defaultPlacement,
    strategy: 'fixed',
  });

  const handleMenuClick = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      update();
    }
  };

  const handleClickOutside = (event) => {
    if (refs.reference.current && refs.reference.current.contains(event.target)) {
      document.addEventListener('click', handleClickOutside, { capture: true, once: true });
      return;
    }
    if (isOpen && refs.floating.current && !refs.floating.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('click', handleClickOutside, { capture: true, once: true });
      window.addEventListener('scroll', closeMenu, { capture: true, once: true });
    }

    return () => {
      document.removeEventListener('click', handleClickOutside, { capture: true, once: true });
      window.removeEventListener('scroll', closeMenu, { capture: true, once: true });
    };
  }, [isOpen]);

  const menuNode = isOpen && (
    <S.DropdownMenu
      ref={refs.setFloating}
      style={{
        position: strategy,
        top: y ?? '',
        left: x ?? '',
        zIndex: 1000,
      }}
    >
      {children}
    </S.DropdownMenu>
  );

  return (
    <>
      <S.BtnContainer>
        <BtnElement ref={refs.setReference} onClick={handleMenuClick} isPressed={isOpen} />
      </S.BtnContainer>
      {ReactDOM.createPortal(menuNode, document.body)}
    </>
  );
};

DropdownMenu.prototype = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  BtnElement: PropTypes.node.isRequired,
};
